import React from 'react'
import logo from '../components/assets/images/logo.png'

const Header = () => {
  return (
    <div className='logo'><img src={logo} alt='MW Car and Commercial logo'/></div>
  )
}

export default Header